/**
 * Mirrors backend/homebase/dugout/filters/billing_item_row_fields.py.
 *
 * Whitelists of BillingReportRow fields that the server-backed grid
 * (BillingItemsList) can sort/filter on, since it queries BillingItem's
 * cached row (a JSONField) rather than holding all rows client-side like
 * BillingReportResultApp does. Fields not listed here either aren't
 * meaningful to sort/filter (errors/warnings/indicators are dicts/lists,
 * claim_id is a frontend-computed composite) or aren't supported by the
 * backend yet, so their sort/filter UI is disabled for this grid.
 */

export const TEXT_ROW_FIELDS = new Set([
  'full_name',
  'service_id',
  'service_type',
  'destination',
  'cpt_code',
  'modifiers',
  'jurisdiction',
  'sex',
  'program_name',
  'program_scope',
  'billing_provider_name_id',
  'phase_name',
  'rendering_provider',
  'rendering_provider_other_id_qualifier',
  'rendering_provider_other_id_number',
  'servicing_provider',
  'servicing_provider_credentials',
  'servicing_provider_role',
  'primary_insurance_plan',
  'insurance_policy',
  'plan',
  'priority_type',
  'insurance_type',
  'attendees',
  'session_status',
  'conducted_via',
  'complexity_level',
  'drug_screen_kind',
  'drug_screen_result',
  'actual_duration_source',
  'chart_id',
  'chart_filled_by',
  'chart_locked_by',
  'chart_locking_role',
  'rendering_provider_mode',
  'service_location',
  'diagnosis_code1',
  'diagnosis_code2',
  'diagnosis_code3',
  'diagnosis_code4',
  'service_class',
  'appointment_id',
  'healthie_errors',
  'manually_associated_by',
  'cms_1500_healthie_id'
]);

// Date/datetime fields -- support `<field>_from`/`<field>_to` range filtering.
export const DATE_ROW_FIELDS = new Set([
  'period_start_at',
  'period_end_at',
  'admitted_at',
  'discharged_at',
  'ignore_error_at',
  'manually_associated_at',
  'manually_held_at'
]);

// Numeric fields -- support `<field>_min`/`<field>_max` range filtering.
export const NUMERIC_ROW_FIELDS = new Set([
  'rate',
  'units',
  'total_charged',
  'total_expected_revenue',
  'encounters_count',
  'actual_duration',
  'scheduled_duration'
]);

// service_date is a real model column (BillingItem.service_at), also
// supports `<field>_from`/`<field>_to` range filtering.
export const REAL_ALIAS_ROW_FIELDS = new Set(['service_date']);

export const SERVER_SORTABLE_ROW_FIELDS = new Set([
  ...TEXT_ROW_FIELDS,
  ...DATE_ROW_FIELDS,
  ...NUMERIC_ROW_FIELDS,
  ...REAL_ALIAS_ROW_FIELDS
]);

// Dict/list/bool-shaped row fields -- not orderable (a dict of lists has no
// natural sort), but filterable server-side for the "quick filter" segments
// (BillingReportFilters), matching
// backend/homebase/dugout/filters/billing_item_filter.py's blank/notBlank,
// on_hold, and indicators_contains/indicators_not_contains support.
// person_id and billing_item_id are included here too -- both are
// exact-match UUID filters (see BillingItemFilter.person_id/billing_item_id),
// not sortable/icontains text columns. person_id is set programmatically
// (e.g. BillingItemsList's handleClaimLoad); billing_item_id is also
// restored from the `billing_item_id` URL param on mount for deep links to a
// single item.
export const SERVER_FILTERABLE_ONLY_ROW_FIELDS = new Set([
  'errors',
  'indicators',
  'on_hold',
  'person_id',
  'billing_item_id'
]);
